import websites from '../../config/websites';

export default {
  computed: {
    websiteName() {
      return websites.currentWebsite().name;
    },
    websiteCategory() {
      return websites.currentWebsite().category;
    },
    websiteUrl() {
      return websites.currentWebsite().url;
    },
    websiteRSS() {
      return `http://rss.${websites.currentWebsite().url}`;
    },
    websiteLogo() {
      return websites.currentWebsite().logo;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/Website.js